import { useField } from 'formik';
import { CSSProperties, FocusEventHandler } from 'react';
import { Form, Icon, Label } from 'semantic-ui-react';

interface Props {
    name: string;    
    label?: string;
    required?: boolean | false;
    disabled?: boolean | false;
    onFocus?: FocusEventHandler;
    onBlur?: FocusEventHandler;
    style?: CSSProperties;
    infomessage?: string;
    showinfo?: boolean | false;
    readOnly?: boolean | false;
}

export default function MyCheckbox(props: Props) {
    const [field, meta] = useField(props.name); 
    return (
        <Form.Field error={meta.touched && !!meta.error} required={props.required}   >           
            <div className="ui checkbox">   
                {props.disabled &&
                    <input  id={props.name} type='checkbox' {...field} {...props} disabled />  
                }
                {!props.disabled &&
                    <input  id={props.name} type='checkbox' {...field} {...props}/>  
                }
                <label htmlFor={props.name}>                    
                    {props.label}
                </label>
            </div>
           
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
            {props.showinfo && props.infomessage && (
                <Label color='blue'> <Icon name='info' />{props.infomessage}</Label>
            )}
        </Form.Field>        
    )
}